var map = {
	"./BOSCH_Logo.svg": 399,
	"./Dashboard_icon.svg": 396,
	"./Dashboard_icon_white.svg": 523,
	"./Inspection_job_report.svg": 388,
	"./Inspection_job_report_white.svg": 524,
	"./Manage_roles.svg": 382,
	"./Manage_roles_white.svg": 525,
	"./Manage_users_icon.svg": 381,
	"./Manage_users_icon_white.svg": 526,
	"./Nav_profile.svg": 380,
	"./add_user_Page.svg": 370,
	"./arrow_dashboard.svg": 369,
	"./arrow_down.svg": 402,
	"./arrow_up.svg": 401,
	"./assign_Transfer_job.svg": 400,
	"./assign_Transfer_job_white.svg": 527,
	"./bosch_logo_01.svg": 404,
	"./cloud_icon_01.svg": 403,
	"./cloud_icon_01_white.svg": 528,
	"./company.svg": 385,
	"./content_upload.svg": 398,
	"./create_inspection_job.svg": 397,
	"./create_inspection_job_white.svg": 529,
	"./deativated_status_icon.svg": 395,
	"./details_icon.svg": 394,
	"./download_pdf.svg": 393,
	"./download_xls.svg": 392,
	"./edit_icon.svg": 391,
	"./export.svg": 390,
	"./industry-icon.svg": 791,
	"./industry.svg": 383,
	"./industry_white.svg": 530,
	"./inprogress_icon.svg": 389,
	"./inspection_dashboard.svg": 405,
	"./inspection_dashboard_white.svg": 531,
	"./job_details_img.svg": 221,
	"./manage_role_technician_icon.svg": 387,
	"./onboard_new_plant.svg": 378,
	"./onboard_new_plant_black.svg": 792,
	"./onboard_new_plant_image.svg": 379,
	"./onboard_new_plant_white.svg": 532,
	"./pictures.svg": 377,
	"./reference_link.svg": 376,
	"./search_icon.svg": 375,
	"./sucess_toast_icon.svg": 374,
	"./thumb.svg": 373,
	"./tick.svg": 372,
	"./truck-transporter-icon.svg": 793,
	"./truck-transporter.svg": 384,
	"./truck-transporter_white.svg": 533,
	"./username_icon.svg": 286,
	"./vehicle.svg": 386,
	"./warning.svg": 371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 790;